<div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/50 px-4 py-12">
  <div class="w-full max-w-md">
    <!-- Logo -->
    <div class="text-center mb-8">
      <img src="selstudiologin.png" alt="Sel Studio" class="h-24 mx-auto mb-2">
      <p class="text-gray-500 text-sm">Project Management Platform</p>
    </div>

    <!-- Card -->
    <div class="bg-white/80 backdrop-blur-xl rounded-2xl shadow-[0_8px_32px_rgba(0,0,0,0.08)] border border-white/50 overflow-hidden">

      <!-- SIGN IN VIEW -->
      @if(currentView === 'signIn') {
        <div class="p-8">
          <h2 class="text-xl font-bold text-gray-900 mb-2">Welcome back</h2>
          <p class="text-gray-500 text-sm mb-6">Sign in to your account to continue</p>

          <!-- Success Message -->
          @if(successMessage) {
            <div class="mb-4 p-3 bg-emerald-50 border border-emerald-200 rounded-xl flex items-start gap-2">
              <svg class="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <p class="text-sm text-emerald-700">{{ successMessage }}</p>
            </div>
          }

          <!-- Error Message -->
          @if(error) {
            <div class="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl flex items-start gap-2">
              <svg class="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <p class="text-sm text-red-700">{{ error }}</p>
            </div>
          }

          <form (ngSubmit)="onSignIn()" class="space-y-4">
            <!-- Email -->
            <div>
              <label for="email" class="block text-sm font-medium text-gray-700 mb-1.5">Email address</label>
              <input type="email" id="email" name="email" [(ngModel)]="email" required
                     class="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 outline-none transition-all hover:border-gray-300"
                     placeholder="you@company.com">
            </div>

            <!-- Password -->
            <div>
              <label for="password" class="block text-sm font-medium text-gray-700 mb-1.5">Password</label>
              <div class="relative">
                <input [type]="showPassword ? 'text' : 'password'" id="password" name="password" [(ngModel)]="password" required
                       class="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 outline-none transition-all pr-12 hover:border-gray-300"
                       placeholder="••••••••">
                <button type="button" (click)="togglePasswordVisibility('password')"
                        class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer">
                  @if(showPassword) {
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
                    </svg>
                  } @else {
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                    </svg>
                  }
                </button>
              </div>
            </div>

            <!-- Forgot Password Link -->
            <div class="text-right">
              <button type="button" (click)="goToForgotPassword()"
                      class="text-sm text-blue-600 hover:text-blue-700 font-medium cursor-pointer">
                Forgot your password?
              </button>
            </div>

            <!-- Submit Button -->
            <button type="submit" [disabled]="loading"
                    class="w-full py-3 px-4 bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-semibold rounded-xl
                           hover:from-blue-600 hover:to-indigo-700 hover:shadow-lg hover:shadow-blue-500/25
                           focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
                           disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2 cursor-pointer shadow-sm">
              @if(loading) {
                <svg class="animate-spin w-5 h-5" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span>Signing in...</span>
              } @else {
                <span>Sign in</span>
              }
            </button>
          </form>
        </div>

        <!-- Footer -->
        <div class="px-8 py-4 bg-gray-50/50 border-t border-gray-100 text-center">
          <p class="text-sm text-gray-500">
            Don't have an account? <span class="text-gray-700 font-medium">Contact your administrator</span>
          </p>
        </div>
      }

      <!-- NEW PASSWORD REQUIRED VIEW (First Login) -->
      @if(currentView === 'newPasswordRequired') {
        <div class="p-8">
          <div class="flex items-center gap-3 mb-6">
            <div class="w-10 h-10 rounded-xl bg-amber-100 flex items-center justify-center">
              <svg class="w-5 h-5 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"/>
              </svg>
            </div>
            <div>
              <h2 class="text-xl font-bold text-gray-900">Set your password</h2>
              <p class="text-gray-500 text-sm">Please create a new password for your account</p>
            </div>
          </div>

          @if(error) {
            <div class="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl flex items-start gap-2">
              <svg class="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <p class="text-sm text-red-700">{{ error }}</p>
            </div>
          }

          <form (ngSubmit)="onConfirmNewPassword()" class="space-y-4">
            <div>
              <label for="newPassword" class="block text-sm font-medium text-gray-700 mb-1.5">New password</label>
              <div class="relative">
                <input [type]="showNewPassword ? 'text' : 'password'" id="newPassword" name="newPassword" [(ngModel)]="newPassword" required
                       class="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 outline-none transition-all pr-12 hover:border-gray-300"
                       placeholder="••••••••">
                <button type="button" (click)="togglePasswordVisibility('newPassword')"
                        class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                  </svg>
                </button>
              </div>
              <p class="text-xs text-gray-500 mt-1.5">Must be at least 8 characters with uppercase, lowercase, number, and special character</p>
            </div>

            <div>
              <label for="confirmNewPassword" class="block text-sm font-medium text-gray-700 mb-1.5">Confirm new password</label>
              <input type="password" id="confirmNewPassword" name="confirmNewPassword" [(ngModel)]="confirmNewPassword" required
                     class="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 outline-none transition-all hover:border-gray-300"
                     placeholder="••••••••">
            </div>

            <button type="submit" [disabled]="loading"
                    class="w-full py-3 px-4 bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-semibold rounded-xl
                           hover:from-blue-600 hover:to-indigo-700 hover:shadow-lg hover:shadow-blue-500/25
                           focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
                           disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2 cursor-pointer shadow-sm">
              @if(loading) {
                <svg class="animate-spin w-5 h-5" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span>Setting password...</span>
              } @else {
                <span>Set password & continue</span>
              }
            </button>
          </form>
        </div>
      }

      <!-- FORGOT PASSWORD VIEW -->
      @if(currentView === 'forgotPassword') {
        <div class="p-8">
          <button (click)="goToSignIn()" class="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 mb-4 cursor-pointer group">
            <svg class="w-4 h-4 transition-transform group-hover:-translate-x-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
            </svg>
            Back to sign in
          </button>

          <div class="flex items-center gap-3 mb-6">
            <div class="w-10 h-10 rounded-xl bg-blue-100 flex items-center justify-center">
              <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
              </svg>
            </div>
            <div>
              <h2 class="text-xl font-bold text-gray-900">Reset password</h2>
              <p class="text-gray-500 text-sm">We'll send you a verification code</p>
            </div>
          </div>

          @if(error) {
            <div class="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl flex items-start gap-2">
              <svg class="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <p class="text-sm text-red-700">{{ error }}</p>
            </div>
          }

          <form (ngSubmit)="onForgotPassword()" class="space-y-4">
            <div>
              <label for="resetEmail" class="block text-sm font-medium text-gray-700 mb-1.5">Email address</label>
              <input type="email" id="resetEmail" name="resetEmail" [(ngModel)]="resetEmail" required
                     class="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 outline-none transition-all hover:border-gray-300"
                     placeholder="you@company.com">
            </div>

            <button type="submit" [disabled]="loading"
                    class="w-full py-3 px-4 bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-semibold rounded-xl
                           hover:from-blue-600 hover:to-indigo-700 hover:shadow-lg hover:shadow-blue-500/25
                           focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
                           disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2 cursor-pointer shadow-sm">
              @if(loading) {
                <svg class="animate-spin w-5 h-5" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span>Sending code...</span>
              } @else {
                <span>Send verification code</span>
              }
            </button>
          </form>
        </div>
      }

      <!-- CONFIRM RESET PASSWORD VIEW -->
      @if(currentView === 'confirmResetPassword') {
        <div class="p-8">
          <button (click)="goToSignIn()" class="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 mb-4 cursor-pointer group">
            <svg class="w-4 h-4 transition-transform group-hover:-translate-x-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
            </svg>
            Back to sign in
          </button>

          <div class="flex items-center gap-3 mb-6">
            <div class="w-10 h-10 rounded-xl bg-emerald-100 flex items-center justify-center">
              <svg class="w-5 h-5 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
              </svg>
            </div>
            <div>
              <h2 class="text-xl font-bold text-gray-900">Enter verification code</h2>
              <p class="text-gray-500 text-sm">Check your email for the code</p>
            </div>
          </div>

          @if(successMessage) {
            <div class="mb-4 p-3 bg-emerald-50 border border-emerald-200 rounded-xl flex items-start gap-2">
              <svg class="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <p class="text-sm text-emerald-700">{{ successMessage }}</p>
            </div>
          }

          @if(error) {
            <div class="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl flex items-start gap-2">
              <svg class="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <p class="text-sm text-red-700">{{ error }}</p>
            </div>
          }

          <form (ngSubmit)="onConfirmResetPassword()" class="space-y-4">
            <div>
              <label for="resetCode" class="block text-sm font-medium text-gray-700 mb-1.5">Verification code</label>
              <input type="text" id="resetCode" name="resetCode" [(ngModel)]="resetCode" required
                     class="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 outline-none transition-all text-center text-lg tracking-widest font-mono hover:border-gray-300"
                     placeholder="000000" maxlength="6">
            </div>

            <div>
              <label for="resetNewPassword" class="block text-sm font-medium text-gray-700 mb-1.5">New password</label>
              <input type="password" id="resetNewPassword" name="resetNewPassword" [(ngModel)]="resetNewPassword" required
                     class="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 outline-none transition-all hover:border-gray-300"
                     placeholder="••••••••">
              <p class="text-xs text-gray-500 mt-1.5">Must be at least 8 characters</p>
            </div>

            <div>
              <label for="confirmResetNewPassword" class="block text-sm font-medium text-gray-700 mb-1.5">Confirm new password</label>
              <input type="password" id="confirmResetNewPassword" name="confirmResetNewPassword" [(ngModel)]="confirmResetNewPassword" required
                     class="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 outline-none transition-all hover:border-gray-300"
                     placeholder="••••••••">
            </div>

            <button type="submit" [disabled]="loading"
                    class="w-full py-3 px-4 bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-semibold rounded-xl
                           hover:from-blue-600 hover:to-indigo-700 hover:shadow-lg hover:shadow-blue-500/25
                           focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
                           disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2 cursor-pointer shadow-sm">
              @if(loading) {
                <svg class="animate-spin w-5 h-5" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span>Resetting password...</span>
              } @else {
                <span>Reset password</span>
              }
            </button>
          </form>
        </div>
      }

    </div>

    <!-- Footer -->
    <p class="text-center text-gray-400 text-sm mt-8">
      © 2026 Sel Studio. All rights reserved.
    </p>
  </div>
</div>
